import {
  ISettingsForm,
  ISettingsResponse,
} from 'services/settings/application/types';
import { DOCUMENT_NUMERATION_TYPE, MONTH } from 'services/types';
import { formatDateToInput } from 'utils/global/date.utils';

export const applicationSettingsQueryToForm = (
  query: ISettingsResponse
): ISettingsForm => ({
  periodType: query.settlementPeriodType.id,
  settlementStartMonth: query.settlementStartMonth ?? MONTH.unknown,
  isrcPrefix: query.isrcPrefix ?? '',
  phoneNumberPrefix: query.phoneNumberPrefix,
  defaultApplicationLanguage: query.defaultApplicationLanguage,
  showOnlyVerifiedArtists: query.showOnlyVerifiedArtists,
  showOnlyVerifiedTracks: query.showOnlyVerifiedTracks,
  showOnlyVerifiedMerch: query.showOnlyVerifiedMerch,
  showNotActiveSalesChannels: query.showNotActiveSalesChannels,
  allowContractsWithSameLabel: query.allowContractsWithSameLabel,
  showOnlySettlementPeriodsWithReports: query.showOnlySettlementPeriodsWithReports,
  documentsConfiguration: {
    settlementShortcut: query.settlementShortcut,
    labelReportShortcut: query.labelReportShortcut,
    advanceRepaymentShortcut: query.advanceRepaymentShortcut,
    advanceFinalShortcut: query.advanceFinalShortcut,
    advanceProposalShortcut: query.advanceProposalShortcut,
    costRepaymentShortcut: query.costRepaymentShortcut,
    ownerReportShortcut: query.ownerReportShortcut,
    trackReportShortcut: query.trackReportShortcut ?? '',
    advanceProposalNumerationType: query.advanceProposalNumerationType.id,
    advanceRepaymentNumerationType: query.advanceRepaymentNumerationType.id,
    advanceFinalNumerationType: query.advanceFinalNumerationType.id,
    settlementNumerationType: query.settlementNumerationType.id,
    labelReportNumerationType: query.labelReportNumerationType.id,
    costRepaymentNumerationType: query.costRepaymentNumerationType.id,
    ownerReportNumerationType: query.ownerReportNumerationType.id,
    trackReportNumerationType:
      query.trackReportNumerationType?.id ?? DOCUMENT_NUMERATION_TYPE.unknown,
  },
  artistDescriptionMaxLength: query.artistDescriptionMaxLength,
  isrcStartNumber: query.isrcStartNumber ?? 0,
  isrcGenerationStartDate: query.isrcGenerationStartDate
    ? formatDateToInput(query.isrcGenerationStartDate, true)
    : '',
  remainingEansNotificationThreshold:
    query.remainingEansNotificationThreshold ?? 0,
  extensionContract: query.extensionContract,
  allowDetailedReport: query.allowDetailedReport ?? false,
  expirationRangeInMonths: query.expirationRangeInMonths,
  defaultThemeMode: query.defaultThemeMode,
  canChangeThemeMode: query.canChangeThemeMode,
  currentTheme: query.currentTheme,
  showOnlyVerifiedMpd: query.showOnlyVerifiedMpd ?? false,
  showOnlyVerifiedMpp: query.showOnlyVerifiedMpp ?? false,
  enableArtistFullName: query.enableArtistFullName ?? false,
  residenceCertificateExpirationRangeInMonths:
    query.residenceCertificateExpirationRangeInMonths ?? 1,
  showOnlyVerifiedVideos: query.showOnlyVerifiedVideos ?? false,
  autoRenewLabelReports: query.autoRenewLabelReports ?? false,
  enableSettlementDeduction: query.enableSettlementDeduction,
  settlementDeductionName: query.enableSettlementDeduction
    ? query.settlementDeductionName
    : null,
  settlementDeductionPercentage: query.enableSettlementDeduction
    ? query.settlementDeductionPercentage
    : null,
  enablePdfPasswordProtection: query.enablePdfPasswordProtection ?? false,
  ...query.emailSendConfiguration,
});
